import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import {
  GetInstallmentOrderDetailsRequestType,
  GetInstallmentOrderDetailsResponseType
} from '../../../services/PaymentServices/APIService/types';
import { getAPIErrorMessage } from '../../../utils/ApiErrorUtils';

import usePaymentServices from '../usePaymentServices';

interface UseGetInstallmentOrderDetailsInterface {
  getInstallmentOrderDetailsApi: UseMutateAsyncFunction<
    GetInstallmentOrderDetailsResponseType,
    unknown,
    GetInstallmentOrderDetailsRequestType,
    unknown
  >;
  error: string | null;
  status: MutationStatus;
}

const useGetInstallmentOrderDetails =
  (): UseGetInstallmentOrderDetailsInterface => {
    const { paymentServices } = usePaymentServices();

    const getInstallmentOrderDetails = (
      requestObject: GetInstallmentOrderDetailsRequestType
    ) => {
      return paymentServices.getInstallmentOrderDetails(requestObject);
    };

    const { mutateAsync, error, status } = useMutation(
      getInstallmentOrderDetails,
      {
        mutationKey: ['getInstallmentOrderDetailsApi']
      }
    );

    return {
      getInstallmentOrderDetailsApi: mutateAsync,
      error: error ? getAPIErrorMessage(error) : null,
      status
    };
  };

export { useGetInstallmentOrderDetails };
